import { Link } from "react-router-dom";
import { Separator } from "@/components/ui/separator";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t bg-background mt-auto">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-sm text-muted-foreground text-center md:text-left">
            <div>© Zoocertica 2025 • Wildlife Compliance Made Simple</div>
            <div className="mt-1">Zoocertica supports licensed zoos, sanctuaries, and private reptile & aquatic keepers.</div>
          </div>
          
          <div className="flex flex-wrap items-center justify-center gap-4 text-sm">
            <Link
              to="/terms"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              Terms of Service
            </Link>
            <Separator orientation="vertical" className="h-4" />
            <Link
              to="/privacy"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              Privacy Policy
            </Link>
            <Separator orientation="vertical" className="h-4" />
            <Link
              to="/sla"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              SLA
            </Link>
            <Separator orientation="vertical" className="h-4" />
            <Link
              to="/contact"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              Contact
            </Link>
            <Separator orientation="vertical" className="h-4" />
            <Link
              to="/help"
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              Help Center
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
